import { createBrowserRouter, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import ProtectedRoute from './ProtectedRoute';
import GuestRoute from './GuestRoute';
import NotFoundPage from '@/app/pages/NotFoundPage';
import RouteErrorBoundary from './RouteErrorBoundary';
import { AppGate } from '../gate/AppGate';
import { authRoutes } from './authRoutes';
import { appRoutes } from './appRoutes';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
	{
		// Pathless root route: its errorElement catches errors from every child —
		// root redirects, auth and app — not just /app.
		errorElement: <RouteErrorBoundary />,
		children: [
			{
				path: '/',
				element: (
					<Navigate
						to='/app/home'
						replace
					/>
				),
			},
			{
				path: '/app',
				element: (
					<Navigate
						to='home'
						replace
					/>
				),
			},
			{
				path: '/home',
				element: (
					<Navigate
						to='/app/home'
						replace
					/>
				),
			},
			{
				element: <ProtectedRoute />,
				children: [
					{
						path: '/app',
						element: <AppGate />,
						children: appRoutes,
					},
				],
			},
			{
				element: <GuestRoute />,
				children: authRoutes,
			},
			{
				path: '*',
				element: <NotFoundPage />,
			},
		],
	},
]);
